import type { PharosApiResponse } from '@klareospace/pharos-lib-types';
import type { ApiClient } from '../api/api-client';

export function createPermissionsApi(client: ApiClient): {
  fetchMyPermissions: () => Promise<string[]>;
} {
  return {
    fetchMyPermissions: async (): Promise<string[]> => {
      const response = await client.execute<PharosApiResponse<string[]>>(() =>
        client.instance.get('/users/me/permissions'),
      );
      return response.data ?? [];
    },
  };
}
